<div [ngSwitch]="compact">
    <ng-container *ngSwitchCase="true">
        <div class="horizontal-container">
            <span>{{ authority | formatAuthority: false:true }}&nbsp; </span>
            <em
                *ngIf="authority.organisation.id !== organisationId"
                class="right-buffer"
                >{{ authority.organisation.name }}</em
            >
            <ng-container *ngIf="authority.authorityType.hasIdentifier">
                <span class="right-buffer">
                    | {{ authority.identifier | defaultTo }}
                </span>
            </ng-container>
            <span class="display-label">&nbsp;</span>
            <span class="right-buffer">
                | {{ authority.startDate | formatDate | defaultTo }}
            </span>
            <ng-container *ngIf="authority.authorityType.hasExpiry">
                |
                <span class="display-label">Exp.&nbsp;</span>
                <span>{{ authority.expiryDate | formatDate | defaultTo }}</span>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="false">
        <div class="display-label">
            {{ authority | formatAuthority: false:true }}
            <em
                *ngIf="authority.organisation.id !== organisationId"
                class="right-buffer"
                >{{ authority.organisation.name }}</em
            >
        </div>
        <div>
            <ng-container *ngIf="authority.authorityType.hasIdentifier">
                <span class="display-label"
                    >{{
                        authority.authorityType.identifierLabel || 'Identifier'
                    }}&nbsp;</span
                >
                <span class="right-buffer">{{
                    authority.identifier | defaultTo
                }}</span>
            </ng-container>
        </div>
        <div>
            <span class="display-label">Start Date&nbsp;</span>
            <span class="right-buffer">{{
                authority.startDate | formatDate | defaultTo
            }}</span>
            <ng-container *ngIf="authority.authorityType.hasExpiry">
                <span class="display-label">Expiry Date&nbsp;</span>
                <span>{{ authority.expiryDate | formatDate | defaultTo }}</span>
            </ng-container>
        </div>
    </ng-container>
</div>
